<app-navbar-style-one></app-navbar-style-one>

<div class="out-of-service-container">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-7 col-md-9 col-sm-11">
                <div class="out-of-service-card text-center">
                    <!-- Header with Logo/Icon -->
                    <div class="service-header mb-5">
                        <div class="icon-wrapper">
                            <i class='bx bx-time-five'></i>
                            <div class="icon-glow"></div>
                        </div>
                        <div class="status-badge">CLOSED</div>
                    </div>

                    <!-- Main Content -->
                    <div class="service-content">
                        <!-- Title -->
                        <h1 class="service-title mb-4">
                            Temporarily Unavailable
                        </h1>

                        <!-- Message -->
                        <p class="service-message mb-4">
                            Our services are currently offline. We're committed to providing 
                            you with exceptional service during our scheduled hours.
                        </p>

                        <!-- Working Hours Section -->
                        <div class="working-hours-section" *ngIf="workingHours">
                            <div class="section-header">
                                <i class='bx bx-calendar'></i>
                                <h4>Working Schedule</h4>
                            </div>
                            <div class="hours-display">
                                <div class="time-slot">
                                    <i class='bx bx-time'></i>
                                    <span>{{workingHours}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Loading State -->
                        <div class="working-hours-section" *ngIf="!workingHours">
                            <div class="section-header">
                                <i class='bx bx-calendar'></i>
                                <h4>Working Schedule</h4>
                            </div>
                            <div class="loading-state">
                                <div class="loading-spinner">
                                    <div class="spinner"></div>
                                </div>
                                <p>Fetching schedule information...</p>
                            </div>
                        </div>

                        <!-- Countdown/Next Opening -->
                        <div class="next-opening mb-5">
                            <div class="info-card">
                                <i class='bx bx-bell'></i>
                                <div class="info-content">
                                    <h6>We'll Be Back Soon</h6>
                                    <p>Follow us for real-time updates on our service status</p>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="action-buttons">
                            <button class="btn-primary" routerLink="/">
                                <i class='bx bx-home'></i>
                                Return to Homepage
                            </button>
                            <button class="btn-secondary" (click)="refreshPage()">
                                <i class='bx bx-refresh'></i>
                                Refresh Status
                            </button>
                        </div>

                        <!-- Contact Info -->
                        <div class="contact-info mt-5">
                            <p class="contact-text">
                                Need immediate assistance?
                                <a href="mailto:{{email}}" class="contact-link">
                                    <i class='bx bx-envelope'></i>
                                    Contact Support
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>